// extracted by mini-css-extract-plugin
export default {"nickName_settings_edit_container":"tB_tC","nickName_settings_edit_input_container":"tB_tE","nickName_settings_input":"tB_tF","nickName_settings_btn":"tB_tG"};